import { can } from "../config";

export default function UnitSwitcher({ units, currentUnit, setCurrentUnit, user }) {
  // This used to also require role === "superadmin". That guard was added because
  // granting "switchUnits" to another role showed the switcher while the server still
  // pinned the user to their own unit, so every request after a switch came back 403
  // and the switcher looked broken. The server now honours the permission
  // (check_unit_access), so the grant is real and the guard would only make the
  // RBAC tick-box lie about what it does.
  if (!can(user, "switchUnits")) return null;

  return (
    <div
      className="flex flex-wrap gap-2 p-3 bg-gray-900 border-b border-gray-700 shrink-0"
      data-testid="unit-switcher"
    >
      <span className="text-xs text-gray-400 self-center whitespace-nowrap mr-1 w-full sm:w-auto">
        Switch Unit:
      </span>
      {units.map(u => (
        <button
          key={u.id}
          onClick={() => setCurrentUnit(u.id)}
          className={`min-h-[44px] px-4 py-2.5 rounded-lg text-sm font-semibold whitespace-nowrap transition-colors touch-manipulation select-none ${
            currentUnit === u.id
              ? "bg-white text-gray-900 shadow"
              : "text-gray-300 hover:bg-gray-700 active:bg-gray-600"
          }`}
          data-testid={`unit-switch-${u.id}`}
        >
          {u.shortName}
        </button>
      ))}
    </div>
  );
}
